import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_products';

export default function MobileMain() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
